module.exports = __webpack_public_path__ + "static/media/token-icon-big.e1b6cd11.png";